<template>
  <div v-if="shouldButtonBeDisplayed">
    <v-btn v-if="prependCancel && currentStep > 0 && currentStep < messages.length" :class="cancelClass" class="caption"
           text @click="resetSteps">{{ cancelText }}
    </v-btn>
    <v-btn :class="customClass"
           :color="currentColor"
           :disabled="disabled"
           :loading="loading"
           :outlined="outlined"
           :text="text"
           @click="increaseStep">{{ currentMessage }}
    </v-btn>
    <v-btn v-if="!prependCancel && currentStep > 0 && currentStep < messages.length" :class="cancelClass"
           class="caption"
           text @click="resetSteps">{{ cancelText }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ConfirmButton",
  props: {
    stepMessages: {
      type: [Array, Boolean],
      default: false,
    },
    stepColors: {
      type: [Array, Boolean],
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    customClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    cancelClass: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideAfterDone: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    prependCancel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultStepMessages: [
        this.$t('save'),
        this.$t('confirm'),
      ],
      currentStep: 0,
    }
  },
  computed: {
    messages() {
      return this.stepMessages ? this.stepMessages : this.defaultStepMessages;
    },
    colors() {
      return this.stepColors ? this.stepColors : false;
    },
    currentColor() {
      if (this.colors && this.colors[this.currentStep]) {
        return this.colors[this.currentStep];
      } else {
        return this.color;
      }
    },
    currentMessage() {
      return this.messages[this.currentStep];
    },
    shouldButtonBeDisplayed() {
      return !this.hideAfterDone || this.currentStep !== this.messages.length || this.loading;
    }
  },
  methods: {
    increaseStep() {
      this.currentStep++;
      if (this.currentStep === this.stepMessages.length) {
        this.$emit('on-confirm-success');
        if (!this.hideAfterDone) this.resetSteps();
      }
    },
    resetSteps() {
      this.currentStep = 0;
    },
  }
}
</script>

<style scoped>

</style>
